export default [
    {
        path: 'bnafar-gerenciamento-envio',
        component: () => import(
            /* webpackChunkName: 'integracao-bnafar-gerenciamento-envio' */
            '@/views/integracao/bnafar/gerenciamento-envio/Index'
        ),
        redirect: 'bnafar-gerenciamento-envio/index',
        children: [
            {
                name: 'integracao-bnafar-gerenciamento-envio-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'integracao-bnafar-gerenciamento-envio' */
                    '@/views/integracao/bnafar/gerenciamento-envio/List.vue'
                ),
            },
        ],
    },
]